import { Capacitor } from "@capacitor/core";

// The version baked into THIS running copy. On the native apps it is the
// binary's own version (Android versionName / iOS MARKETING_VERSION, read
// through @capacitor/app); on the web there is no installed copy, so it is
// null and the site always counts as current.
export async function installedAppVersion() {
  if (typeof window !== "undefined" && window.__msAppVersion) return String(window.__msAppVersion); // test/dev override
  if (!Capacitor.isNativePlatform()) return null;
  try {
    const { App } = await import("@capacitor/app");
    const info = await App.getInfo();
    return (info && info.version) || null;
  } catch {
    return null;
  }
}

// Each platform releases on its own schedule (Android can ship before iOS),
// so the admin may set per-platform versions; blank falls back to the shared
// App version / minimum.
export function latestAppVersion(settings, platform) {
  const s = settings || {};
  if (platform === "ios") return s.versionIos || s.version || "";
  if (platform === "android") return s.versionAndroid || s.version || "";
  return s.version || "";
}

export function minAppVersion(settings, platform) {
  const s = settings || {};
  if (platform === "ios") return s.minVersionIos || s.minVersion || "";
  if (platform === "android") return s.minVersionAndroid || s.minVersion || "";
  return s.minVersion || "";
}

// Piecewise numeric compare: "1.2.10" > "1.2.9", "1.2" == "1.2.0".
// Returns -1, 0 or 1.
export function compareVersions(a, b) {
  const pa = String(a || "").split(".").map((n) => parseInt(n, 10) || 0);
  const pb = String(b || "").split(".").map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    if ((pa[i] || 0) !== (pb[i] || 0)) return (pa[i] || 0) < (pb[i] || 0) ? -1 : 1;
  }
  return 0;
}
